import { z } from "zod";
import { zQueryBoolean } from "@common/schemas/query-boolean.schema";

export const DocumentFlowStatusFiltersSchema = z.object({
    isImported: zQueryBoolean().optional(),
    isImporting: zQueryBoolean().optional(),
    isNotImported: zQueryBoolean().optional(),
    isDocReconciled: zQueryBoolean().optional(),
    isDocReconciling: zQueryBoolean().optional(),
    isDocNotReconciled: zQueryBoolean().optional(),
    isDocMatched: zQueryBoolean().optional(),
    isDocNotMatched: zQueryBoolean().optional(),
});

export type DocumentFlowStatusFilters = z.infer<
    typeof DocumentFlowStatusFiltersSchema
>;
